import React from 'react';
import { TrendingUpIcon, UsersIcon, DollarSignIcon, BellIcon } from 'lucide-react';
export function FuturePacing() {
  return <section className="w-full px-4 py-16 md:py-20 bg-gradient-to-b from-purple-900/30 to-slate-900/50" data-id="element-114">
      <div className="max-w-4xl mx-auto" data-id="element-115">
        <h2 className="text-3xl md:text-5xl font-bold text-white text-center mb-10 leading-tight" data-id="element-116">
          Imagina esto...
        </h2>
        <div className="bg-gradient-to-br from-purple-500/20 to-pink-500/20 border border-purple-500/30 rounded-2xl p-6 md:p-8 mb-6" data-id="element-117">
          <p className="text-base md:text-xl text-gray-200 mb-6" data-id="element-118">
            Mañana por la mañana abres tu teléfono y ves:
          </p>
          <div className="bg-slate-800/70 border border-purple-400 rounded-xl p-6 mb-6" data-id="element-119">
            <p className="text-lg md:text-2xl font-bold text-purple-300 text-center flex items-center justify-center gap-2 flex-wrap" data-id="element-120">
              <BellIcon className="w-6 h-6" data-id="element-121" />
              "Tu video ha alcanzado 10,000 vistas"
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-122">
            <div className="bg-slate-800/50 p-4 rounded-lg text-center" data-id="element-123">
              <TrendingUpIcon className="w-8 h-8 text-green-400 mx-auto mb-2" data-id="element-124" />
              <p className="text-sm md:text-base text-gray-300" data-id="element-125">
                Comentarios nuevos
              </p>
            </div>
            <div className="bg-slate-800/50 p-4 rounded-lg text-center" data-id="element-126">
              <UsersIcon className="w-8 h-8 text-blue-400 mx-auto mb-2" data-id="element-127" />
              <p className="text-sm md:text-base text-gray-300" data-id="element-128">
                Seguidores creciendo
              </p>
            </div>
            <div className="bg-slate-800/50 p-4 rounded-lg text-center" data-id="element-129">
              <DollarSignIcon className="w-8 h-8 text-yellow-400 mx-auto mb-2" data-id="element-130" />
              <p className="text-sm md:text-base text-gray-300" data-id="element-131">
                Ventas entrando
              </p>
            </div>
          </div>
          <p className="text-sm md:text-lg text-gray-300 mb-4" data-id="element-132">
            Sin editor, sin horas grabando, sin estrés.
          </p>
          <p className="text-sm md:text-lg text-gray-300 mb-4" data-id="element-133">
            Solo hiciste clic en "generar", y la IA hizo el trabajo pesado.
          </p>
        </div>
        <div className="text-center" data-id="element-134">
          <p className="text-xl md:text-2xl font-bold text-white mb-4 leading-tight" data-id="element-135">
            Ahora imagina hacer esto una y otra vez…
          </p>
          <p className="text-base md:text-xl text-gray-300 mb-6" data-id="element-136">
            Construyendo tu biblioteca de videos virales. Creciendo en piloto
            automático.
          </p>
          <p className="text-base md:text-xl text-purple-400 font-semibold" data-id="element-137">
            Ese es el poder de Viral Video Machine IA. Y puedes empezar hoy.
          </p>
        </div>
      </div>
    </section>;
}